export const PATH = {
  GLOBAL: '/*',
  HOME: '/',
  HOMEPAGE: '/homepage',
  JOB_DETAILS: '/job-details',
  LOGIN: '/',
  SIDEBAR: '/sidebar',
  ASSIGN: '/assign',
  JOBS: '/jobs',
  INTERVIEWER: '/interviewer',
  ONGOING: '/ongoing-interviews',
  PREVIOUS: '/interview-feedback',
  PAST_INTERVIEWER: '/past-interviews',
  INTERVIEWS: '/interviews',
  FEEDBACK: '/feedback',
  PROFILE: '/profile',
  RESUME: '/resume',
  DASHBOARD: '/dashboard',
  APPLICATION: '/application',
  SELECT_ROLE: '/select-role',
  REGISTER_COMPANY: '/register-company',
  REGISTER: '/register',
  UNAUTHORIZED: '/unauthorized',
  MISSING: '/missing',
};
